module.exports = __webpack_public_path__ + "static/img/l-1.af1ac768.png";